import "features/reports/testReport/components/SchoolTestReport.css";
import CoverPage from "../shared/CoverPage";
import Chart from "../shared/Chart";
import AboutSection from "./AboutSection";
import ChartNoteWrapperBig from "../shared/ChartNoteWrapperBig";
import TableRow from "../shared/TableRow";
import MarkGroup from "../shared/MarkGroup";
import Units from "../shared/Units";
import ChartSubsection from "./ChartSubsection";
import ScrollBar from "../../../../../shared/ui/ScrollBar";

const Report = ({ reportSummary, gradeLevels, graphData}: any) => {

    return (
        <>
            <div className="cover-bg cover-test-peach">
                <div id="print_page" className="wrapper-cover">
                    <CoverPage coverImage="/images/reports/cover-literatie.png" type="literacy">
                        <div className="title">
                            <h1>Testul de literație </h1>
                            <h2>
                                Sesiune #{reportSummary.testId}
                            </h2>
                            <h1>Indice de literație {reportSummary.score}</h1>
                            <h2> {reportSummary.studentName && `Elev: ${reportSummary.studentName}`}</h2>
                        </div>
                    </CoverPage>

                    <div className="pagebreak"></div>

                    <AboutSection />

                    <div className="pagebreak"></div>

                    <div className="section-despre">
                        <h1>Indicele de literație: {reportSummary.score} din 100</h1>
                        <Chart
                            testScore={reportSummary.score}
                            type="literacy"
                        />
                    </div>

                    <div className="pagebreak"></div>
                    {graphData.length > 0 && (
                        <div className="section-despre">
                            <h1>Profilul competențelor evaluate</h1>
                            <ScrollBar forceVisible="x" autoHide={false}  >
                            <table className="tabel-note">
                                <thead>
                                <tr>
                                    <th className="col-capitol">&nbsp;</th>
                                    <th className="col-values">
                                        <Units type="literacy"/>
                                        <MarkGroup type="literacy" />
                                    </th>
                                </tr>
                                </thead>

                                {graphData.map((section: any, index: any) => (
                                    <tbody key={index}>
                                    <TableRow section={section} index={index} />
                                    </tbody>
                                ))}
                                <tfoot>
                                <tr className="legenda">
                                    <td>&nbsp;</td>
                                    <td className="col-legend">
                                        <img src="/images/reports/chart-tabel-literatie.png" className="chart-tabel" alt="" />
                                        <Units type="literacy"/>
                                        <ChartNoteWrapperBig big={false} type="literacy" />
                                    </td>
                                </tr>
                                </tfoot>
                            </table>
                            </ScrollBar>
                        </div>
                    )}

                    <div className="pagebreak"></div>
                    {gradeLevels.length > 0 && (
                        <div className="section-despre">
                            <h1>Interpretarea indicelui de literație</h1>
                            <p>
                                Mai jos este prezentată semnificația indicelui de literație rezultat în urma evaluării elevilor, în funcție de
                                încadrarea scorului la nivelul de alfabetizare subdezvoltată (scor între 0 și 25), nivelul funcțional al
                                alfabetizării (26-80) sau nivelul înalt al alfabetizării (81-100).
                            </p>
                            {gradeLevels.slice(0)
                                .reverse().map((gradeLevel: any, index: any) => (
                                <ChartSubsection gradeLevel={gradeLevel} score={reportSummary.score} key={index} type="literacy"/>))}
                            </div>

                    )}
                </div>
            </div>
        </>
    );
};

export default Report;
